import type { SortConfig } from './types';

export const useSortableHeader = (sort: () => SortConfig) => {
  const nextSort = (key: string): SortConfig =>
    sort().key === key ? { key, order: sort().order === 'desc' ? 'asc' : 'desc' } : { key, order: 'desc' };

  const sortIconClass = (key: string) => (sort().key === key ? 'text-slate-900' : 'text-slate-300');

  return { nextSort, sortIconClass };
};
